import React from 'react';
import styled from 'styled-components';
import Button, { StyledButton, ButtonProps } from '../../../../Button/Button';
import HStack from '../../../../HStack/HStack';
import CustomText from '../../../../Typography/CustomText/CustomText';
import { SiteKitIcon } from '../../SiteKitIcon/SiteKitIcon';

// Fragments
const TriggerWrapper = styled.div`
  > ${StyledButton} {
    line-height: inherit;
  }
`;

// Exports
interface SiteKitSignPostContextSelectorTriggerProps extends ButtonProps {
  hasSubtitle?: boolean;
}
const SiteKitSignPostContextSelectorTrigger = ({
  children,
  hasSubtitle = true,
  ...buttonProps
}: SiteKitSignPostContextSelectorTriggerProps) => (
  <TriggerWrapper>
    <Button {...buttonProps} type="aura">
      <HStack spacing="6px">
        <CustomText as="span" color="black" whiteSpace="nowrap" size={hasSubtitle ? 'xlarge' : '18'} weight="medium">
          {children}
        </CustomText>
        <SiteKitIcon theme="light" icon="chevron-circle-down" />
      </HStack>
    </Button>
  </TriggerWrapper>
);

SiteKitSignPostContextSelectorTrigger.displayName = 'SiteKit.Header.SignPost.ContextSelectorTrigger';

export { SiteKitSignPostContextSelectorTrigger, SiteKitSignPostContextSelectorTriggerProps };
